var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-opportunity",
    attrs: {
      error: _vm.error,
      loading: _vm.loading,
      isCustomizable: _vm.settings.isCustomizable
    },
    on: {
      "hide-card": function($event) {
        return _vm.$emit("hide-card", _vm.type)
      },
      "edit-card": _vm.toggleSettingsForm,
      "refresh-card": function($event) {
        return _vm.fetchCard(_vm.type, {}, true)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function() {
          return [
            _vm.settings.canCreate
              ? _c("CompassIconButton", {
                  attrs: {
                    icon: "plus",
                    onclick: "Opportunity.addOpportunity()"
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("template-kpi-card", {
              attrs: { data: { stats: _vm.cardData, labels: _vm.labels } }
            }),
            _vm._v(" "),
            _c(
              "portal",
              { attrs: { to: "dashboardSettingsForm" } },
              [
                _vm.showSettingsForm
                  ? _c("card-setting-overlay", {
                      attrs: {
                        formName: _vm.settingsFormName,
                        cardCustomSettings: _vm.customSettings,
                        cardName: _vm.type
                      },
                      on: {
                        fetched: _vm.fetchCard,
                        "close-form": _vm.toggleSettingsForm,
                        "custom-settings-saved": function($event) {
                          return _vm.fetchCard(_vm.type, {}, true)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }